<mat-tree #tree [dataSource]="dataSource" [treeControl]="treeControl">
  <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
    <a [routerLink]="node.routeName">{{ node.label }} </a>
  </mat-tree-node>
</mat-tree>
